const css = `.compact-branch-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
.compact-branch-item i {
  font-size: var(--font-size-base);
  color: var(--text-color-secondary);
}
.compact-branch-item .branch-color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid var(--surface-border);
}
.compact-branch-item .compact-branch-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}

.adaptive-select-option .compact-branch-item {
  padding: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQ29tcGFjdEJyYW5jaFNlbGVjdCIsInNvdXJjZXMiOlsiQ29tcGFjdEJyYW5jaFNlbGVjdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7OztBQUtGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuY29tcGFjdC1icmFuY2gtaXRlbSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogOHB4O1xuICBwYWRkaW5nOiA0cHggMDtcblxuICBpIHtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1iYXNlKTtcbiAgICBjb2xvcjogdmFyKC0tdGV4dC1jb2xvci1zZWNvbmRhcnkpO1xuICB9XG5cbiAgLmJyYW5jaC1jb2xvci1kb3Qge1xuICAgIHdpZHRoOiAxMHB4O1xuICAgIGhlaWdodDogMTBweDtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgZmxleC1zaHJpbms6IDA7XG4gICAgYm9yZGVyOiAxcHggc29saWQgdmFyKC0tc3VyZmFjZS1ib3JkZXIpO1xuICB9XG5cbiAgLmNvbXBhY3QtYnJhbmNoLW5hbWUge1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWJhc2UpO1xuICAgIGZvbnQtd2VpZ2h0OiB2YXIoLS1mb250LXdlaWdodC1tZWRpdW0pO1xuICB9XG59XG5cbi5hZGFwdGl2ZS1zZWxlY3Qtb3B0aW9uIHtcbiAgLmNvbXBhY3QtYnJhbmNoLWl0ZW0ge1xuICAgIHBhZGRpbmc6IDA7XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
